module.exports = __webpack_public_path__ + "static/challenge-bg-f65537776339c51025cd1e5e7bbae58d.png";